export default __webpack_public_path__ + "static/media/Landingpage Victory.e51d9d42.mp4";